import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=0863925e&scoped=true&"
import script from "./EventModal.vue?vue&type=script&lang=ts&"
export * from "./EventModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventModal.vue?vue&type=style&index=0&id=0863925e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863925e",
  null
  
)

export default component.exports